import { mockResponse } from '@/utils/format'

const months = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
const STANDARDS = ['ISO 14067', 'PAS 2050', 'GHG Protocol Product Standard']

const MODEL_STATUS = [
  { value: 'draft', label: '编制中' },
  { value: 'published', label: '已发布' }
]

const ACCOUNTING_STATUS = [
  { value: 'pending', label: '待核算' },
  { value: 'running', label: '进行中' },
  { value: 'review', label: '待审核' },
  { value: 'completed', label: '已完成' }
]

const LABEL_STATUS = [
  { value: 'draft', label: '待审核' },
  { value: 'published', label: '已发布' }
]

const models = [
  {
    id: 'model-1',
    name: '车身结构件碳足迹模型',
    productName: '车身结构件-钢铁制品',
    functionalUnit: '1件',
    standard: 'ISO 14067',
    nodeCount: 12,
    status: 'published',
    statusLabel: '已发布',
    updatedAt: '2025-07-01'
  },
  {
    id: 'model-2',
    name: '铝合金轮毂碳足迹模型',
    productName: '铝合金轮毂',
    functionalUnit: '1个',
    standard: 'ISO 14067',
    nodeCount: 8,
    status: 'published',
    statusLabel: '已发布',
    updatedAt: '2025-06-28'
  },
  {
    id: 'model-3',
    name: '动力电池包碳足迹模型',
    productName: '动力电池包',
    functionalUnit: '1套',
    standard: 'PAS 2050',
    nodeCount: 18,
    status: 'published',
    statusLabel: '已发布',
    updatedAt: '2025-06-20'
  },
  {
    id: 'model-4',
    name: '内饰塑料件碳足迹模型',
    productName: '内饰塑料件',
    functionalUnit: '1套',
    standard: 'ISO 14067',
    nodeCount: 6,
    status: 'published',
    statusLabel: '已发布',
    updatedAt: '2025-06-15'
  },
  {
    id: 'model-5',
    name: '车用玻璃碳足迹模型',
    productName: '车用玻璃',
    functionalUnit: '1块',
    standard: 'GHG Protocol Product Standard',
    nodeCount: 7,
    status: 'published',
    statusLabel: '已发布',
    updatedAt: '2025-06-10'
  },
  {
    id: 'model-6',
    name: '橡胶轮胎碳足迹模型',
    productName: '橡胶轮胎',
    functionalUnit: '1条',
    standard: 'ISO 14067',
    nodeCount: 10,
    status: 'draft',
    statusLabel: '编制中',
    updatedAt: '2025-07-04'
  }
]

const accountingTasks = [
  {
    id: 'acc-1',
    taskNo: 'CF-2025-001',
    productName: '车身结构件-钢铁制品',
    modelId: 'model-1',
    modelName: '车身结构件碳足迹模型',
    functionalUnit: '1件',
    footprint: 12.5,
    standard: 'ISO 14067',
    year: 2025,
    status: 'completed',
    statusLabel: '已完成',
    completedAt: '2025-07-05',
    stageBreakdown: [
      { stage: '原材料', emission: 5.25, ratio: 42 },
      { stage: '生产制造', emission: 3.5, ratio: 28 },
      { stage: '运输', emission: 1.5, ratio: 12 },
      { stage: '使用', emission: 1.25, ratio: 10 },
      { stage: '废弃', emission: 1.0, ratio: 8 }
    ]
  },
  {
    id: 'acc-2',
    taskNo: 'CF-2025-002',
    productName: '铝合金轮毂',
    modelId: 'model-2',
    modelName: '铝合金轮毂碳足迹模型',
    functionalUnit: '1个',
    footprint: 8.3,
    standard: 'ISO 14067',
    year: 2025,
    status: 'completed',
    statusLabel: '已完成',
    completedAt: '2025-07-03',
    stageBreakdown: [
      { stage: '原材料', emission: 3.49, ratio: 42 },
      { stage: '生产制造', emission: 2.32, ratio: 28 },
      { stage: '运输', emission: 1.0, ratio: 12 },
      { stage: '使用', emission: 0.83, ratio: 10 },
      { stage: '废弃', emission: 0.66, ratio: 8 }
    ]
  },
  {
    id: 'acc-3',
    taskNo: 'CF-2025-003',
    productName: '动力电池包',
    modelId: 'model-3',
    modelName: '动力电池包碳足迹模型',
    functionalUnit: '1套',
    footprint: 45.2,
    standard: 'PAS 2050',
    year: 2025,
    status: 'running',
    statusLabel: '进行中',
    completedAt: '-',
    stageBreakdown: []
  },
  {
    id: 'acc-4',
    taskNo: 'CF-2025-004',
    productName: '内饰塑料件',
    modelId: 'model-4',
    modelName: '内饰塑料件碳足迹模型',
    functionalUnit: '1套',
    footprint: 3.2,
    standard: 'ISO 14067',
    year: 2025,
    status: 'review',
    statusLabel: '待审核',
    completedAt: '2025-06-28',
    stageBreakdown: [
      { stage: '原材料', emission: 1.34, ratio: 42 },
      { stage: '生产制造', emission: 0.9, ratio: 28 },
      { stage: '运输', emission: 0.38, ratio: 12 },
      { stage: '使用', emission: 0.32, ratio: 10 },
      { stage: '废弃', emission: 0.26, ratio: 8 }
    ]
  },
  {
    id: 'acc-5',
    taskNo: 'CF-2025-005',
    productName: '车用玻璃',
    modelId: 'model-5',
    modelName: '车用玻璃碳足迹模型',
    functionalUnit: '1块',
    footprint: 5.8,
    standard: 'GHG Protocol Product Standard',
    year: 2025,
    status: 'completed',
    statusLabel: '已完成',
    completedAt: '2025-06-25',
    stageBreakdown: [
      { stage: '原材料', emission: 2.44, ratio: 42 },
      { stage: '生产制造', emission: 1.62, ratio: 28 },
      { stage: '运输', emission: 0.7, ratio: 12 },
      { stage: '使用', emission: 0.58, ratio: 10 },
      { stage: '废弃', emission: 0.46, ratio: 8 }
    ]
  }
]

const evaluations = [
  {
    id: 'eval-1',
    reportName: '车身结构件-钢铁制品 产品碳足迹报告',
    productName: '车身结构件-钢铁制品',
    accountingId: 'acc-1',
    reportYear: 2025,
    evalType: 'third_party',
    evalTypeLabel: '第三方核查',
    evaluator: '中国质量认证中心',
    score: 92,
    result: 'passed',
    resultLabel: '通过',
    evalDate: '2025-07-06',
    status: 'completed',
    statusLabel: '已完成',
    checklist: ['边界定义合理', '数据质量满足要求', '计算方法符合标准'],
    dataQuality: '良好',
    conclusion: 'passed',
    remarks: '核算过程规范，数据可追溯。'
  },
  {
    id: 'eval-2',
    reportName: '铝合金轮毂 产品碳足迹报告',
    productName: '铝合金轮毂',
    accountingId: 'acc-2',
    reportYear: 2025,
    evalType: 'internal',
    evalTypeLabel: '内部审核',
    evaluator: '质量部-张工',
    score: 88,
    result: 'passed',
    resultLabel: '通过',
    evalDate: '2025-07-04',
    status: 'completed',
    statusLabel: '已完成',
    checklist: ['边界定义合理', '数据质量满足要求'],
    dataQuality: '良好',
    conclusion: 'passed',
    remarks: ''
  },
  {
    id: 'eval-3',
    reportName: '车用玻璃 产品碳足迹报告',
    productName: '车用玻璃',
    accountingId: 'acc-5',
    reportYear: 2025,
    evalType: 'internal',
    evalTypeLabel: '内部审核',
    evaluator: 'ESG 管理部',
    score: 0,
    result: 'pending',
    resultLabel: '待评价',
    evalDate: '',
    status: 'pending',
    statusLabel: '待评价',
    checklist: [],
    dataQuality: '',
    conclusion: '',
    remarks: ''
  },
  {
    id: 'eval-4',
    reportName: '内饰塑料件 产品碳足迹报告',
    productName: '内饰塑料件',
    accountingId: 'acc-4',
    reportYear: 2025,
    evalType: 'internal',
    evalTypeLabel: '内部审核',
    evaluator: 'ESG 管理部',
    score: 0,
    result: 'pending',
    resultLabel: '待评价',
    evalDate: '',
    status: 'pending',
    statusLabel: '待评价',
    checklist: [],
    dataQuality: '',
    conclusion: '',
    remarks: ''
  }
]

const labels = [
  {
    id: 'label-1',
    labelNo: 'CL-2025-001',
    productName: '车身结构件-钢铁制品',
    accountingId: 'acc-1',
    evaluationId: 'eval-1',
    footprint: 12.5,
    functionalUnit: '1件',
    standard: 'ISO 14067',
    validFrom: '2025-07-06',
    validTo: '2026-07-05',
    year: 2025,
    status: 'published',
    statusLabel: '已发布'
  },
  {
    id: 'label-2',
    labelNo: 'CL-2025-002',
    productName: '铝合金轮毂',
    accountingId: 'acc-2',
    evaluationId: 'eval-2',
    footprint: 8.3,
    functionalUnit: '1个',
    standard: 'ISO 14067',
    validFrom: '2025-07-04',
    validTo: '2026-07-03',
    year: 2025,
    status: 'published',
    statusLabel: '已发布'
  },
  {
    id: 'label-3',
    labelNo: 'CL-2025-003',
    productName: '车用玻璃',
    accountingId: 'acc-5',
    evaluationId: 'eval-3',
    footprint: 5.8,
    functionalUnit: '1块',
    standard: 'GHG Protocol Product Standard',
    validFrom: '',
    validTo: '',
    year: 2025,
    status: 'draft',
    statusLabel: '待审核'
  }
]

export function getModelDetailData() {
  return mockResponse({
    modelTree: [
      {
        id: 'root',
        label: '车身结构件-钢铁制品',
        children: [
          {
            id: 'transport',
            label: '货物运输',
            children: [{ id: 'transport-1', label: '公路运输, 货运, 柴油, 载重 7.5-32t' }]
          },
          {
            id: 'gas',
            label: '天然气',
            children: [{ id: 'gas-1', label: '天然气燃烧过程' }]
          },
          {
            id: 'pack',
            label: '包装',
            children: [{ id: 'pack-1', label: '瓦楞纸箱' }]
          },
          {
            id: 'steel',
            label: '非合金钢 | 转炉炼钢生产',
            children: [
              { id: 'steel-1', label: '型钢轧制, 钢材' },
              { id: 'steel-2', label: '锰' },
              { id: 'steel-3', label: '铁矿石' }
            ]
          }
        ]
      }
    ],
    currentNodeId: 'steel',
    inputs: [
      { name: '型钢轧制, 钢材', unitCategory: '质量', upstream: '型材轧制, 钢', attribute: '原料 (外购)' },
      { name: '锰', unitCategory: '质量', upstream: '金属加工, 锰', attribute: '原料 (外购)' },
      { name: '铁矿石', unitCategory: '质量', upstream: '铁矿石开采', attribute: '原料 (外购)' },
      { name: '货物运输', unitCategory: '个数', upstream: '货物运输', attribute: '原料运输' }
    ],
    outputs: [
      { name: '车身结构件-钢铁制品', unitCategory: '质量', downstream: '-', attribute: '-' },
      { name: '危险废物, 用于焚烧', unitCategory: '质量', downstream: '待焚烧危险废物处理', attribute: '废弃物处理' },
      { name: '废水, 平均', unitCategory: '体积', downstream: '废水, 平均处理', attribute: '废弃物处理' }
    ],
    basicInfo: {
      processName: '非合金钢 | 转炉炼钢生产',
      category: '生产制造',
      location: '中国',
      description: '车身结构件钢铁制品生命周期模型'
    }
  })
}

export function getHomeData() {
  return mockResponse({
    standards: STANDARDS,
    year: 2025,
    annualStats: {
      productCount: { value: 28, yoy: 12.5 },
      avgFootprint: { value: 3.86, unit: 'kgCO2e/件', yoy: -5.2 }
    },
    monthlyTrend: {
      months,
      completedCount: [1, 2, 3, 2, 4, 3, 5, 2, 1, 3, 2, 0]
    },
    productRanking: [
      { name: '车身结构件-钢铁制品', footprint: 12.5 },
      { name: '铝合金轮毂', footprint: 8.3 },
      { name: '动力电池包', footprint: 45.2 },
      { name: '内饰塑料件', footprint: 3.2 },
      { name: '车用玻璃', footprint: 5.8 },
      { name: '橡胶轮胎', footprint: 15.6 },
      { name: '电子控制单元', footprint: 2.1 },
      { name: '座椅总成', footprint: 6.4 },
      { name: '制动系统', footprint: 4.7 },
      { name: '空调压缩机', footprint: 7.9 }
    ],
    stageContribution: [
      { name: '原材料', value: 42 },
      { name: '生产制造', value: 28 },
      { name: '运输', value: 12 },
      { name: '使用', value: 10 },
      { name: '废弃', value: 8 }
    ],
    recentRecords: [
      { productName: '车身结构件-钢铁制品', functionalUnit: '1件', footprint: 12.5, standard: 'ISO 14067', status: '已完成', completedAt: '2025-07-05' },
      { productName: '铝合金轮毂', functionalUnit: '1个', footprint: 8.3, standard: 'ISO 14067', status: '已完成', completedAt: '2025-07-03' },
      { productName: '动力电池包', functionalUnit: '1套', footprint: 45.2, standard: 'PAS 2050', status: '进行中', completedAt: '-' },
      { productName: '内饰塑料件', functionalUnit: '1套', footprint: 3.2, standard: 'ISO 14067', status: '待审核', completedAt: '2025-06-28' },
      { productName: '车用玻璃', functionalUnit: '1块', footprint: 5.8, standard: 'GHG Protocol Product Standard', status: '已完成', completedAt: '2025-06-25' }
    ]
  })
}

export function getModelListData(params = {}) {
  const productName = (params.productName || '').trim()
  const standard = params.standard || ''
  const status = params.status || ''

  let list = models.map(item => ({ ...item }))
  if (productName) {
    list = list.filter(item => item.productName.includes(productName) || item.name.includes(productName))
  }
  if (standard) {
    list = list.filter(item => item.standard === standard)
  }
  if (status) {
    list = list.filter(item => item.status === status)
  }

  const published = list.filter(item => item.status === 'published').length
  const draft = list.filter(item => item.status === 'draft').length

  return mockResponse({
    standards: STANDARDS,
    statusOptions: MODEL_STATUS,
    summary: {
      total: { today: list.length, annual: list.length, unit: '个' },
      published: { today: published, annual: published, unit: '个' },
      draft: { today: draft, annual: draft, unit: '个' }
    },
    models: list
  })
}

export function getAccountingData(params = {}) {
  const year = params.year || ''
  const standard = params.standard || ''
  const status = params.status || ''

  let list = accountingTasks.map(item => ({ ...item }))
  if (year) {
    list = list.filter(item => String(item.year) === String(year))
  }
  if (standard) {
    list = list.filter(item => item.standard === standard)
  }
  if (status) {
    list = list.filter(item => item.status === status)
  }

  const running = list.filter(item => item.status === 'running').length
  const completed = list.filter(item => item.status === 'completed').length
  const review = list.filter(item => item.status === 'review').length

  const publishedModels = models
    .filter(item => item.status === 'published')
    .map(item => ({
      id: item.id,
      name: item.name,
      productName: item.productName,
      functionalUnit: item.functionalUnit,
      standard: item.standard
    }))

  return mockResponse({
    standards: STANDARDS,
    statusOptions: ACCOUNTING_STATUS,
    summary: {
      total: { today: list.length, annual: list.length, unit: '项' },
      running: { today: running, annual: running, unit: '项' },
      completed: { today: completed, annual: completed, unit: '项' },
      review: { today: review, annual: review, unit: '项' }
    },
    monthlyTrend: {
      months,
      completedCount: [1, 2, 3, 2, 4, 3, 5, 2, 1, 3, 2, 0]
    },
    stageContribution: [
      { name: '原材料', value: 42 },
      { name: '生产制造', value: 28 },
      { name: '运输', value: 12 },
      { name: '使用', value: 10 },
      { name: '废弃', value: 8 }
    ],
    publishedModels,
    tasks: list
  })
}

export function getEvaluationData(params = {}) {
  const year = params.year || ''
  const evalType = params.evalType || ''
  const result = params.result || ''

  let list = evaluations.map(item => ({ ...item, checklist: [...(item.checklist || [])] }))
  if (year) {
    list = list.filter(item => String(item.reportYear) === String(year))
  }
  if (evalType) {
    list = list.filter(item => item.evalType === evalType)
  }
  if (result) {
    list = list.filter(item => item.result === result)
  }

  const pending = list.filter(item => item.status === 'pending').length
  const passed = list.filter(item => item.result === 'passed').length
  const rectify = list.filter(item => item.result === 'rectify' || item.result === 'conditional').length

  const availableTasks = accountingTasks
    .filter(item => item.status === 'completed')
    .filter(item => !evaluations.some(e => e.accountingId === item.id && e.status === 'completed'))
    .map(item => ({
      id: item.id,
      name: `${item.productName} 产品碳足迹报告`,
      productName: item.productName,
      year: item.year
    }))

  return mockResponse({
    evalTypes: [
      { value: 'internal', label: '内部审核' },
      { value: 'third_party', label: '第三方核查' }
    ],
    resultOptions: [
      { value: 'passed', label: '通过' },
      { value: 'conditional', label: '有条件通过' },
      { value: 'rectify', label: '需整改' },
      { value: 'pending', label: '待评价' }
    ],
    checklistOptions: [
      '边界定义合理',
      '功能单位明确',
      '数据质量满足要求',
      '计算方法符合标准',
      '不确定性分析充分'
    ],
    dataQualityOptions: ['优秀', '良好', '一般', '较差'],
    availableTasks,
    summary: {
      pending: { today: pending, annual: pending, unit: '份' },
      passed: { today: passed, annual: passed, unit: '份' },
      rectify: { today: rectify, annual: rectify, unit: '份' }
    },
    resultDist: [
      { name: '通过', value: passed },
      { name: '有条件通过', value: list.filter(item => item.result === 'conditional').length },
      { name: '需整改', value: list.filter(item => item.result === 'rectify').length },
      { name: '待评价', value: pending }
    ],
    evaluations: list
  })
}

export function getLabelData(params = {}) {
  const productName = (params.productName || '').trim()
  const status = params.status || ''
  const year = params.year || ''

  let list = labels.map(item => ({ ...item }))
  if (productName) {
    list = list.filter(item => item.productName.includes(productName))
  }
  if (status) {
    list = list.filter(item => item.status === status)
  }
  if (year) {
    list = list.filter(item => String(item.year) === String(year))
  }

  const published = list.filter(item => item.status === 'published').length
  const draft = list.filter(item => item.status === 'draft').length

  const availableTasks = evaluations
    .filter(item => item.result === 'passed' && item.status === 'completed')
    .filter(item => !labels.some(l => l.evaluationId === item.id && l.status === 'published'))
    .map(item => {
      const acc = accountingTasks.find(a => a.id === item.accountingId)
      return {
        id: item.id,
        accountingId: item.accountingId,
        productName: item.productName,
        footprint: acc ? acc.footprint : 0,
        functionalUnit: acc ? acc.functionalUnit : '',
        standard: acc ? acc.standard : ''
      }
    })

  return mockResponse({
    statusOptions: LABEL_STATUS,
    summary: {
      total: { today: list.length, annual: list.length, unit: '个' },
      published: { today: published, annual: published, unit: '个' },
      draft: { today: draft, annual: draft, unit: '个' }
    },
    availableTasks,
    labels: list
  })
}

export function getDatabaseData(params = {}) {
  const keyword = (params.keyword || '').trim()
  const category = params.category || ''
  const source = params.source || ''

  const categories = ['原材料', '能源', '运输', '生产制造', '废弃物处理']
  const sources = ['ecoinvent', 'CLCD', '自建']

  let datasets = [
    {
      id: 1,
      name: '公路运输, 货运, 柴油, 载重 7.5-32t',
      processType: '运输',
      category: '运输',
      region: '中国',
      unit: 'tkm',
      footprint: 0.156,
      source: 'ecoinvent',
      year: 2024,
      refCount: 28
    },
    {
      id: 2,
      name: '铁矿石开采',
      processType: '原材料',
      category: '原材料',
      region: '中国',
      unit: 'kg',
      footprint: 0.042,
      source: 'CLCD',
      year: 2024,
      refCount: 15
    },
    {
      id: 3,
      name: '型材轧制, 钢',
      processType: '生产制造',
      category: '生产制造',
      region: '中国',
      unit: 'kg',
      footprint: 1.85,
      source: 'CLCD',
      year: 2024,
      refCount: 22
    },
    {
      id: 4,
      name: '天然气燃烧过程',
      processType: '能源',
      category: '能源',
      region: '中国',
      unit: 'MJ',
      footprint: 0.056,
      source: 'ecoinvent',
      year: 2024,
      refCount: 18
    },
    {
      id: 5,
      name: '瓦楞纸箱',
      processType: '包装',
      category: '原材料',
      region: '中国',
      unit: 'kg',
      footprint: 0.98,
      source: '自建',
      year: 2025,
      refCount: 6
    },
    {
      id: 6,
      name: '金属加工, 锰',
      processType: '原材料',
      category: '原材料',
      region: '中国',
      unit: 'kg',
      footprint: 3.12,
      source: 'ecoinvent',
      year: 2024,
      refCount: 9
    }
  ]

  if (keyword) {
    datasets = datasets.filter(item => item.name.includes(keyword))
  }
  if (category) {
    datasets = datasets.filter(item => item.category === category)
  }
  if (source) {
    datasets = datasets.filter(item => item.source === source)
  }

  const unitProcesses = [
    { id: 1, name: '公路运输, 货运, 柴油, 载重 7.5-32t', ioSummary: '输入: 柴油 1kg → 输出: 运输服务 1tkm', dataset: 'ecoinvent 3.9' },
    { id: 2, name: '铁矿石开采', ioSummary: '输入: 电力、柴油 → 输出: 铁矿石 1kg', dataset: 'CLCD 0.9' },
    { id: 3, name: '型材轧制, 钢', ioSummary: '输入: 钢坯、电力 → 输出: 型钢 1kg', dataset: 'CLCD 0.9' },
    { id: 4, name: '天然气燃烧过程', ioSummary: '输入: 天然气 1m³ → 输出: 热能 1MJ', dataset: 'ecoinvent 3.9' },
    { id: 5, name: '瓦楞纸箱', ioSummary: '输入: 废纸浆、电力 → 输出: 纸箱 1kg', dataset: '自建数据集' }
  ]

  const gwpValues = [
    { gas: 'CO₂', gwp: 1, version: 'AR5', standard: 'IPCC AR5', year: 2024 },
    { gas: 'CH₄', gwp: 28, version: 'AR5', standard: 'IPCC AR5', year: 2024 },
    { gas: 'N₂O', gwp: 265, version: 'AR5', standard: 'IPCC AR5', year: 2024 },
    { gas: 'HFC-134a', gwp: 1300, version: 'AR5', standard: 'IPCC AR5', year: 2024 },
    { gas: 'SF₆', gwp: 23500, version: 'AR5', standard: 'IPCC AR5', year: 2024 }
  ]

  const totalRefs = datasets.reduce((sum, item) => sum + item.refCount, 0)

  return mockResponse({
    categories,
    sources,
    summary: {
      totalDatasets: { today: datasets.length, annual: datasets.length, unit: '条' },
      updatedThisYear: { today: 1, annual: 1, unit: '条' },
      totalRefs: { today: totalRefs, annual: totalRefs, unit: '次' }
    },
    datasets,
    unitProcesses,
    gwpValues
  })
}
